import { create } from "zustand";

type LocationState = {
	data: string;
	timeZone: string;
	setData: (x: string) => void;
	setTimeZone: (x: string) => void;
};

const initialState = {
	data: "",
	timeZone: "",
};

export const useTimeLocation = create<LocationState>((set) => ({
	...initialState,
	setData: (data: string) => set((state) => ({ ...state, data })),
	setTimeZone: (data: string) => set((state) => ({ ...state, data })),
}));
